import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';

//const PrettoSlider = styled(Slider)({
//    height: 15,
//    width: "90%",
//    marginLeft: 20,
//    justify: "center",
//    '& .MuiSlider-thumb': {
//      height: 21,
//      width: 21,
//      backgroundColor: '#fff',
//      border: '2px solid currentColor',
//      marginTop: -9,
//      marginLeft: -9,
//      '&:focus, &:hover, &.Mui-active': {
//        boxShadow: 'inherit',
//      },
//    },
//    '& .MuiSlider-valueLabel': {
//      left: 'calc(-25% + 4px)',
//      scale: (0.01)
//    },
//    '& .MuiSlider-track': {
//      height: 15,
//      borderRadius: 4,
//      opacity: 0.01,
//      
//    },
//    '& .MuiSlider-rail': {
//      height: 15,
//      borderRadius: 4,
//      marginTop: -6,
//      marginLeft: -10,
//      backgroundColor: "#002D55"
//      width: "105%"
//    },
//  });

const PrettoSlider = withStyles({
  root: {
    color: '#FFA500',
    height: 15,
    '& .Mui-disabled': {
      color: '#FFA500',
      height: 18.5,
      width: 18.5,
      marginLeft: -14,
      marginTop: -4.5,
    }      
  },
  thumb: {
    display: 'none', // hide thumb
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 12px)',
    top: -22,
    '& *': {
      background: 'transparent',
      color: '#000',
    },
    '& .Mui-disabled': {
      left: 'calc(-50% + 12px)',
      top: -22,
      '& *': {
        background: 'transparent',
        color: '#000',
    }
  }},
  track: {
    height: 8,
    borderRadius: 4,
    backgroundColor: '#FF7F27', // orange
  },
  rail: {
    height: 8,
    borderRadius: 4,
    opacity: 0.7,
    backgroundColor: 'rgba(220,220,220,0.7)', // light grey, slightly transparent
  },
  mark: {
    backgroundColor: '#002D55',
    height: 0.1,
    width: 0.1,
    marginTop: 3,
    opacity: 0.1,
  },
  markActive: {
    opacity: 1,
    marginTop: 2,
    backgroundColor: '#002D55',
  },
})(Slider);

function valuetext(value) {
  return `${value} %`;
}

export default function DiscreteSlider(props) {
  const [sliderVal, setSliderVal] = useState(0);

  useEffect(() => {
    if (props.value !== undefined && props.value !== null) {
      setSliderVal(props.value);
    }
  }, [props.value]);

  const clampedValue = Math.max(0, Math.min(100, Number(sliderVal) || 0));
  const startLabel = props.startLabel || 'Progress';
  const endLabel = props.endLabel || `${clampedValue}% complete`;
  const caption = props.caption || '';

  // Define marks inside the component so it updates with sliderVal
  const marks = [
    {
      value: 0,
      label: startLabel,
    },
    {
      value: 100,
      label: endLabel,
    },
  ];

  return (
    <div>
      <PrettoSlider
        defaultValue={0}
        getAriaValueText={valuetext}
        step={1}
        value={clampedValue}
        onChange={(event, value) => {
          setSliderVal(value);
        }}
        disabled
        marks={marks}
        min={0}
        max={100}
      />
      {caption ? (
        <Typography style={{ marginTop: 4, fontSize: 'clamp(10px, 0.85vw, 12px)', color: '#486d86', fontWeight: 600, textAlign: 'left' }}>
          {caption}
        </Typography>
      ) : null}
    </div>
  );
}
